import { instantiateSection } from '../../document/hydrate.js';
import { PAGE_DOCUMENT_SCHEMA_VERSION, } from '../../document/types.js';
import { welcomePopupMeta, welcomePopupPresets, welcomePopupSchema, } from '../welcome-popup/schema.js';
/**
 * La définition SANS son composant, juste ce qu'il faut à l'instanciateur (schéma + préréglage).
 *
 * Le composant n'est pas importé ici volontairement : ce module est lu par la graine de thème, donc par
 * l'éditeur, et l'éditeur charge le code de rendu d'une section seulement quand une page l'affiche
 * (registre paresseux). Un import du composant ramènerait la fenêtre dans le paquet d'entrée de
 * l'éditeur pour toutes les vendeuses qui ne l'ouvrent jamais.
 */
const DEFINITION = {
    type: 'welcome-popup',
    schema: welcomePopupSchema,
    presets: welcomePopupPresets,
    meta: welcomePopupMeta,
};
/**
 * LE document par défaut de la fenêtre de bienvenue (feature 0074, lot B).
 *
 * **Un seul modèle, et c'est tout.** Décision de la fondatrice, 18/10/2026 : « oublie la partie de créer
 * des modèles, on va faire juste un modèle par défaut qui va s'ouvrir dans le builder, c'est aux seller
 * de le configurer ». La galerie de modèles prévue au lot A est annulée — la fenêtre s'ouvre toujours
 * sur la même carte, et la vendeuse la refait à sa main.
 *
 * Deux lecteurs doivent être d'accord, exactement comme pour la page de remerciement :
 *   - l'ÉDITEUR l'ouvre quand la boutique n'a pas encore de ligne `(welcome-popup, default)`, ce qui est
 *     le cas de TOUTES les boutiques existantes ;
 *   - la VITRINE s'y replie pour les mêmes boutiques, sinon la fenêtre cesserait simplement de
 *     s'afficher le jour où elle devient un document.
 *
 * Passer par `instantiateSection` plutôt que d'écrire l'arbre à la main n'est pas un raccourci : c'est
 * lui qui remplit les défauts de CHAQUE champ de CHAQUE bloc. `hydrateDocument` ne le fait que pour les
 * réglages de la section, jamais pour ceux des blocs — un arbre écrit à la main ouvrirait l'inspecteur
 * sur des contrôles vides. C'est lui aussi qui traduit les marqueurs `@t:` du préréglage, ce qui fait
 * qu'une boutique arabe ouvre une fenêtre arabe sans qu'on ait semé 26 documents.
 *
 * @param locale la langue de la BOUTIQUE — elle décide des phrases semées ET est écrite dans le
 *   document, comme pour tous les autres gabarits.
 */
export function buildWelcomePopupDocument(locale = 'fr') {
    return {
        schemaVersion: PAGE_DOCUMENT_SCHEMA_VERSION,
        template: 'welcome-popup',
        handle: 'default',
        locale,
        sections: [instantiateSection(DEFINITION, 0, locale)],
    };
}
//# sourceMappingURL=welcomePopupPage.js.map